// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__2YJUH","title":"card_title__3vq55","inActive":"card_inActive__-n-H3"};